import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { usePlandokumenterForPlan } from '@origo/planregister';
import { Loader, Notice } from '@origo/origo-ui';
import DocumentsPage from './DocumentsPage';
import { toDocumentItem } from '../../mappers/toDocuments';

interface DocumentsContainerProps {
    napId: string;
}

const DocumentsContainer: React.FC<DocumentsContainerProps> = ({ napId }) => {
    const { t } = useTranslation();
    const { data, isLoading, isError } = usePlandokumenterForPlan(napId);

    // Nyeste øverst — sorterer på dokumentdato (desc). Dokumenter uten
    // dato havner sist, sortert stabilt etter opprinnelig array-orden.
    const items = useMemo(() => {
        const sorted = [...(data ?? [])].sort((a, b) => {
            const aTime = a.dokumentdato?.getTime() ?? -Infinity;
            const bTime = b.dokumentdato?.getTime() ?? -Infinity;
            return bTime - aTime;
        });
        return sorted.map(doc => toDocumentItem(doc, t));
    }, [data, t]);

    if (isLoading) return <Loader label={t('common.loading')} />;
    if (isError) return <Notice variant="danger">{t('common.errorLoading')}</Notice>;

    return (
        <DocumentsPage
            items={items}
            onOpen={id => {
                const doc = data?.find(d => d.dokumentId === id);
                if (doc?.referansedokumentfil) {
                    window.open(doc.referansedokumentfil, '_blank', 'noopener,noreferrer');
                }
            }}
        />
    );
};

export default DocumentsContainer;
